export const services = [
  {
    id: 'pricing',
    slug: 'pricing-benchmarking-service',
    title: 'Pricing Research and Pricing Metrics',
    groupName: 'For Enterprises',
    icon: 'research',
  },
  {
    id: 'azure-costs',
    // If change it, change the slug in the gatsby-node.js
    slug: 'finops-azure-cost-optimisation',
    title: 'Microsoft Azure Cloud Cost Optimisation',
    groupName: 'For Enterprises',
    icon: 'azure-cloud',
  },
  {
    id: 'ea-negotiation',
    slug: 'microsoft-contract-negotiation-support',
    title: 'Microsoft Enterprise Agreement Negotiation',
    groupName: 'For Enterprises',
    icon: 'agreement',
  },
  {
    id: 'azure-contracts',
    slug: 'microsoft-azure-contract-negotiation-macc',
    title: 'Microsoft Azure Contract Negotiation',
    groupName: 'For Enterprises',
    icon: 'azure-negotiation',
  },
  {
    id: 'm365-planning',
    slug: 'microsoft-365-optimization',
    title: 'Microsoft 365 Planning and Optimisation',
    groupName: 'For Enterprises',
    icon: '365',
  },
  {
    id: 'audit-defense',
    slug: 'microsoft-audit-defense',
    title: 'Microsoft Audit Defense',
    groupName: 'For Enterprises',
    icon: 'defense',
  },
  {
    id: 'spla-csp-defense',
    slug: 'microsoft-spla-audit-defense',
    title: 'SPLA and CSP-Hoster Audit Defense',
    groupName: 'For Providers',
    icon: 'audit-defense',
  },
  {
    id: 'spla-managed',
    slug: 'microsoft-spla-managed-service',
    title: 'Microsoft SPLA Managed Service',
    groupName: 'For Providers',
    icon: 'spla-providers',
  },
] as const

export type ServiceGroupType = 'for-enterprises' | 'for-providers'
export type ServiceIdType = (typeof services)[number]['id']

export function makeServiceFullSlug(serviceId: ServiceIdType | ServiceGroupType) {
  const service = services.find(s => s.id === serviceId)
  if (!service) return `/services/${serviceId}`
  return `/services/${service.slug}/`
}

export function makeServiceIconPath(serviceId: ServiceIdType) {
  const service = services.find(s => s.id === serviceId)
  return `/services/icons/${service.icon}.svg`
}

export function getServiceTitle(serviceId: ServiceIdType) {
  const service = services.find(s => s.id === serviceId)
  return service?.title ?? ''
}
